export default "__VITE_ASSET__DsIuRyn8__"